import { Palette, Stack, Typography } from "@mui/material";
import { useStyle } from "./style";
import { LabeledButton } from "@common/LabeledButton/LabeledButton";
import { Loader } from "@common/Loader/Loader";

interface IParams {
    buttonId: string;
    buttonLabel: string;
    color: keyof Palette;
    isLoading?: boolean;
    onClick: () => void;
    subTitle?: string;
    title: string;
}

export const HomeStickyBanner = (props: IParams) => {
    const { buttonId, buttonLabel, color, isLoading, onClick, subTitle, title } = props;
    const { classes } = useStyle({ color });

    return (
        <div className={classes.banner}>
            <Stack className={classes.bannerWrapper} direction="row">
                <Stack flex={1}>
                    <Typography className={classes.title} color={`${color}.contrastText`}>
                        {title}
                    </Typography>
                    {subTitle && (
                        <Typography color={`${color}.contrastText`} variant="small">
                            {subTitle}
                        </Typography>
                    )}
                </Stack>
                {isLoading ? (
                    <Stack className={classes.loaderWrapper}>
                        <Loader size={40} />
                    </Stack>
                ) : (
                    <LabeledButton
                        className={classes.bannerButton}
                        disableFullWidth
                        id={buttonId}
                        labelText={buttonLabel}
                        onClick={onClick}
                    >
                        {buttonLabel}
                    </LabeledButton>
                )}
            </Stack>
        </div>
    );
};
